<template>
  <card
    dis-hover
    class="c-day-event"
    :padding="0"
    @click.native="eventClickHandler(event.customData, $event)"
  >
    <div class="c-day-event__header ms-small-head">
      {{ event.customData.label }}
    </div>
    <div class="c-day-event__info">
      <div class="ms-text">
        Шифр: {{ event.customData.code }}
      </div>
      <div class="ms-help">
        Заказчик: {{ event.customData.customer }}
      </div>
    </div>
    <div v-if="event.customData.manual_done" class="c-day-event__action">
      <i-button
        @click="completeTask(event.customData.id)"
        type="success"
        size="small"
      >
        Завершить
      </i-button>
    </div>
  </card>
</template>

<script>
import { getFormattedCosts } from '@/utils'

export default {
  props: ['event'],
  methods: {
    eventClickHandler ({ contract_id }, e) {
      if (e.target.tagName === 'BUTTON' || e.target.tagName === 'SPAN') return

      const route = this.$router.resolve({
        path: `/app/contracts/${contract_id}/overview`
      })

      window.open(route.href, '_blank')
    },
    async completeTask (id) {
      try {
        const url = `page/workflow/${id}?action=done`
        await this.$store.dispatch('PUT_REQUEST', { url })

        this.$store.commit('SET_DASHBOARD_PROP', ['needToUpdate', true])
      } catch (error) {
        console.log(error)
      }
    },
    getFormattedCosts
  }
}
</script>

<style lang="less">
.c-day-event {
  font-size: 11px;
  cursor: pointer;
  background-color: rgba(@dt-dark-bg, 0.65) !important;

  &:hover {
    border-color: rgba(@primary-color, 0.6) !important;
  }

  &:not(:first-child) {
    margin-top: 8px;
  }

  &__header {
    border-bottom: 1px solid rgba(@dt-dark-primary, 1);
    padding: 4px;
  }

  &__info {
    padding: 4px;
  }

  .ms-text {
    margin-bottom: 2px;
  }

  &__action {
    padding: 4px;

    .ivu-btn {
      width: 100%;
    }
  }
}

.dark {
  .ivu-modal {
    .c-day-event {
      background-color: @dt-dark-card !important;
    }
  }
}

.light {
  .c-day-event {
    background-color: #fcfcfc !important;

    &__header {
      border-bottom: 1px solid #dcdee2;
    }
  }
}
</style>
